/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage /* useAuth */} from '../modules/auth'
import {App} from '../App'
import {useGetUser} from '../hooks/useGetUser'
import {ToastContainer} from 'react-toastify'

import 'react-toastify/dist/ReactToastify.css'
// import {LayoutSplashScreen} from '../../_metronic/layout/core'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
// const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const {user, statusUser} = useGetUser()
  if (statusUser === 'checking') {
    return (
      <div className='vh-100 d-flex flex-column align-items-center justify-content-center'>
        <div>
          {/* <img
              src='/media/logos/default-dark.svg'
              className='dark-logo'
              alt='Metronic dark logo'
            /> */}
          <img
            src='/media/jeisat/logo.png'
            className='light-logo'
            alt='Jeisat light logo'
            width={300}
          />
        </div>
        <span className='d-block' style={{alignSelf: 'center'}}>
          Validando ...
        </span>
      </div>
    )
  }
  return (
    <BrowserRouter>
      <ToastContainer />
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          {user ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/dashboard' />} />
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
